import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.makeHeadingsLinkable();
    this.scrollToHash();
  }

  makeHeadingsLinkable() {
    this.element.querySelectorAll('h1, h2, h3').forEach((heading) => {
      // Use the text content of the heading to create a unique ID
      const id = heading.textContent.trim().toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]+/g, '');
      heading.id = id;

      // Optional: Create an anchor link element for the heading
      const anchor = document.createElement('a');
      anchor.href = `#${id}`;
      anchor.textContent = '#';
      anchor.style.marginLeft = '8px';
      
      // Append the anchor next to the heading text
      heading.appendChild(anchor);
    });
  }

  scrollToHash() {
    if (window.location.hash) {
      const hash = window.location.hash;
      const targetElement = document.querySelector(hash);
      if (targetElement) {
        targetElement.scrollIntoView();
      }
    }
  }
}